import React from 'react'
import { Tooltip, Whisper } from 'rsuite'
import theme from '../../styles/theme'
import { Badge } from './styles/AIPlusBadge.styles'

// Interface for AIPlusBadge props
interface AIPlusBadgeProps {
  disabled?: boolean
  children?: React.ReactNode
  [key: string]: any // For additional props passed via ...props
}

// AIPlusBadge component with tooltip
const AIPlusBadge: React.FC<AIPlusBadgeProps> = ({
  disabled,
  children,
  ...props
}) => {
  const tooltipText = disabled
    ? 'AI+ is not active. By subscribing to AI+ you can get tailor-made analyses based on company information, your strategy, project description, industry and competition context.'
    : 'AI+ is active. The AI+ agent gives you a tailor-made analysis based on your customized context.'

  return (
    <Whisper
      placement="top"
      trigger="hover"
      speaker={
        <Tooltip
          style={{
            backgroundColor: theme.colors.surface,
            color: theme.colors.veryVeryFadedText,
            outline: `1px solid ${theme.colors.veryVeryVeryFadedText}`,
          }}
        >
          {tooltipText}
        </Tooltip>
      }
    >
      <Badge disabled={disabled} {...props}>
        {children || 'AI +'}
      </Badge>
    </Whisper>
  )
}

export default AIPlusBadge
